module.exports = require("jsoneditor");